<template>
    <tab-section title="Lighting Power Density (LPD)">
        <template v-slot:information>
            If the project is using space-by-space method, provide a total project average.
        </template>
        <div class="uk-grid uk-grid-small" data-uk-grid-margin>
            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Standard</div>
                <form-select
                    id="lighting_efficiency_standard"
                    name="lighting_efficiency_standard"
                    v-model="record.lighting_efficiency_standard"
                    :options="lighting_efficiency_standards"
                    empty-label="(None)"
                    :editable="editable"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_field"
                />
            </div>

            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Target LPD</div>
                <div class="uk-flex uk-flex-middle">
                    <form-input
                        id="target_lpd"
                        type="float"
                        name="target_lpd"
                        v-model="record.target_lpd"
                        :error="has_error('target_lpd')"
                        :editable="editable"
                        :required="false"
                        class="uk-flex-item-1 uk-display-inline-block"
                        @input="save_field"
                    />
                    <span class="uk-margin-small-left uk-margin-small-right uk-flex-item-none">
                        watts&nbsp;per&nbsp;<span v-html="lpd_units.label"></span>
                    </span>
                </div>
            </div>

            <div class="uk-width-1-3">
                <div class="uk-form-controls-text uk-text-bold">Final LPD</div>
                <div class="uk-flex uk-flex-middle">
                    <form-input
                        id="final_lpd"
                        type="float"
                        name="final_lpd"
                        v-model="record.final_lpd"
                        :error="has_error('final_lpd')"
                        :editable="editable"
                        :required="false"
                        class="uk-flex-item-1 uk-display-inline-block"
                        @input="save_field"
                    />
                    <span class="uk-margin-small-left uk-margin-small-right uk-flex-item-none">watts&nbsp;per</span>
                    <form-radio-buttons
                        id="lpd_units"
                        name="lpd_units"
                        v-model="record.lpd_units"
                        :options="lpds"
                        label-field="label"
                        :error="has_error('lpd_units')"
                        :editable="editable"
                        :required="false"
                        class=" uk-flex-item-none"
                        @input="save_field"
                    />
                </div>
            </div>
        </div>
    </tab-section>
</template>

<script type="text/javascript">
import is_project_tab_section from "../mixins/IsProjectTabSection"
import string_utilities from "../../../mixins/StringUtilities"

import FormSelect from "../../../ui/FormSelect"
import FormInput from "../../../ui/FormInput"
import FormRadioButtons from "../../../ui/FormRadioButtons"

export default {
    mixins: [is_project_tab_section, string_utilities],
    components: {
        FormSelect,
        FormInput,
        FormRadioButtons
    },
    computed: {
        lpds () {
            return this.dictionary("lpd")
        },
        lpd_units () {
            const record = this.record
            return this.lpds.find(lpd => lpd.id === record.lpd_units) || {}
        },
        lighting_efficiency_standards () {
            return this.dictionary("lighting_efficiency_standard")
        }
    }
}
</script>
